module.exports = __webpack_public_path__ + "static/me-685b3814ceb4616454e4af59bf3ad93e.jpg";